var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{ref:"videoPlayerElement",staticClass:"video-js vjs-default-skin vjs-16-9"})
}
var staticRenderFns = []

export { render, staticRenderFns }